// This is the base for splide carousel, the full documentation can be found on https://splidejs.com/events/
// The Grid extension is just used when the carousel display are not in line but on a group,
// So the carousel changes the whole group of elements and not one by one.
// The grid extensions and functions can be deleted if it's not in the website design.

import Splide from '@splidejs/splide';
import { merge } from 'lodash';
// import Grid from '@splidejs/splide-extension-grid';

const bootstrapBreakpoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1400,
};

const splideArrowPath =
	'M10.54,21.43H24.61l-3,3A1.65,1.65,0,0,0,24,26.77l5.89-6a1.66,1.66,0,0,0,0-2.32l-6-6a1.65,1.65,0,0,0-2.34,2.33l3,3h-14a1.84,1.84,0,0,0,0,3.67Z';

const splideConfiguration = {
	default: {
		arrowPath: splideArrowPath,
		type: 'loop',
		start: 0,
		perPage: 3,
		focus: 1,
		mediaQuery: 'min',
		breakpoints: {
			640: {
				perPage: 3,
			},
		},
	},
	'hero-carousel': {
		start: 1,
		type: 'loop',
		interval: 5000,
		autoplay: true,
		pagination: false,
		arrows: false,
		focus: true,
		width: '100%',
		padding: 0,
	},
	'hero-slides-carousel': {
		pagination: false,
		cover: true,
		start: 0,
		arrows: false,

		autoplay: true,
		type: 'loop',
		interval: 5000,
	},
	'card-deck': {
		arrowPath: splideArrowPath,
		type: 'loop',
		start: 0,
		perPage: 1,
		pagination: true,
		focus: 'center',
		padding: '5rem',
		mediaQuery: 'min',
		breakpoints: {
			[bootstrapBreakpoints.sm]: {
				perPage: 3,
			},
			[bootstrapBreakpoints.md]: {
				perPage: 3,
			},
		},
	},
	'text-carousel': {
		arrowPath: splideArrowPath,
		type: 'loop',
		start: 0,
		perPage: 1,
		perMove: 1,
		focus: 0,
		pagination: true,
		arrows: true,
		breakpoints: {
			640: {
				perPage: 1,
				focus: 0,
			},
		},
	},
	'testimonial-carousel': {
		pagination: false,
		cover: true,
		start: 0,
		arrows: false,

		autoplay: true,
		type: 'loop',
		interval: 5000,
	},
};

function initializeSplide() {
	const splides = document.getElementsByClassName('splide');
	let current = 0,
		thumbnails;

	const addThumbnail = (splider, coverElement) => {
		const initThumbnail = (thumbnail, index) => {
			thumbnail.addEventListener('click', () => {
				splider.go(index);
			});
		};

		thumbnails = Array.prototype.slice.call(
			coverElement.nextElementSibling.children
		);

		current = thumbnails[splider?.options?.start ?? 0];
		current.classList.add('is-active');

		thumbnails.forEach((thumbnail, index) => {
			initThumbnail(thumbnail, index);
		});

		splider.on('mounted move', () => {
			const thumbnail = thumbnails[splider.index];

			if (thumbnail) {
				if (current) current.classList.remove('is-active');

				thumbnail.classList.add('is-active');
				current = thumbnail;
			}
		});
	};

	[...splides].forEach((splide) => {
		let config = splideConfiguration.default;

		const configAttr = splide.getAttribute('data-splide-config');
		if (configAttr !== undefined && configAttr !== '') {
			const isArrowEnable = !!splide.getAttribute('data-arrow-enable');
			const isPaginationEnable = !!splide.getAttribute(
				'data-pagination-enable'
			);

			if (isArrowEnable) splideConfiguration[configAttr].arrows = true;
			if (isPaginationEnable)
				splideConfiguration[configAttr].pagination = true;

			config = splideConfiguration[configAttr];
		}

		// Check for disable settings
		const disableAttr = splide.getAttribute('data-splide-disable');
		if (disableAttr !== null && disableAttr !== '') {
			const disableBreakpoints = disableAttr.split(',');

			// Track if a breakpoint has been disabled.
			let disableFlag = false;

			for (const breakpoint in bootstrapBreakpoints) {
				if (disableBreakpoints.includes(breakpoint)) {
					const disableObj = {};
					disableObj[bootstrapBreakpoints[breakpoint]] = {
						destroy: true,
					};

					config = merge(config, {
						breakpoints: disableObj,
					});

					disableFlag = true;
				} else if (disableFlag === true) {
					const disableObj = {};
					disableObj[bootstrapBreakpoints[breakpoint]] = {
						destroy: false,
					};

					config = merge(config, {
						breakpoints: disableObj,
					});

					disableFlag = false;
				}
			}
		}

		const splider = new Splide(splide, config).mount();

		const hasThumbnailEnable = splide.getAttribute('data-thumbnail');

		// addon
		if (hasThumbnailEnable === 'enable') addThumbnail(splider, splide);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initializeSplide();
});
